<p-dialog
  [visible]="visible"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="delete-user-blocked-dialog"
  [header]="'dialogs.blockedTitle' | translate"
>
  <div class="delete-user-blocked__body" *ngIf="content">
    <p
      class="delete-user-blocked__primary"
      [innerHTML]="content.primaryHtml"
    ></p>
    <p class="delete-user-blocked__secondary">{{ content.secondaryText }}</p>
  </div>

  <ng-template pTemplate="footer">
    <button type="button" class="delete-user-blocked__close" (click)="onClose()">
      {{ 'dialogs.close' | translate }}
    </button>
  </ng-template>
</p-dialog>
